import { Button } from 'components/Button';
import IButton from 'components/Button/shared/types/button';
import { ReactNode } from 'react';

export default function CMSCustomButton({ children, ...restProps }: { children: ReactNode } & IButton) {
    return <Button {...restProps}>{children}</Button>;
}
